/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PropertiesSetupBody model module.
 * @module model/PropertiesSetupBody
 * @version 1.0.0
 */
export class PropertiesSetupBody {
  /**
   * Constructs a new <code>PropertiesSetupBody</code>.
   * @alias module:model/PropertiesSetupBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertiesSetupBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertiesSetupBody} obj Optional instance to populate.
   * @return {module:model/PropertiesSetupBody} The populated <code>PropertiesSetupBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertiesSetupBody();
      if (data.hasOwnProperty('propertyIdToClone'))
        obj.propertyIdToClone = ApiClient.convertToType(data['propertyIdToClone'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} propertyIdToClone
 */
PropertiesSetupBody.prototype.propertyIdToClone = undefined;

